import { SettingsItems } from '@connect-x-app/shared-domain-models';
import { API_FACTORY, sortPushNotificationSettings } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils/http';

export const updateSettings = (settings: SettingsItems): Promise<SettingsItems> =>
  HttpClient.put<SettingsItems>(API_FACTORY.v2('settings'), settings);

export const fetchSettings = async (): Promise<SettingsItems> => {
  const { pushNotifications, ...settings } = await HttpClient.get<SettingsItems>(API_FACTORY.v2('settings'));
  return {
    ...settings,
    pushNotifications: sortPushNotificationSettings(pushNotifications),
  };
};
